var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('CuToastSheet',{attrs:{"show":_vm.toastSheet.show,"type":_vm.toastSheet.type,"title":_vm.toastSheet.title,"description":_vm.toastSheet.description},on:{"close":_vm.dismissToastSheet}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }